export interface Attachment {
  id: string;
  fileName: string;
  extension: string;
  filePath: string;
  contentType: string;
  titleAr?: string;
  titleEn?: string;
  descriptionAr?: string;
  descriptionEn?: string;
  attachmentTypeId: Number;
  thumbnail: any;
  size?:number;
  fileContent?: string;
}
export interface AttachmentList {
  id: string;
  title: string;
  description?: string;
  fileLanguage?: string;
  entityAttachmentId?: string;
}

export interface AttachmentDto
{
    id?: string;
    entityAttachmentId?: string;
    fileName?: string;
    extension?: string;
    contentType?: string;
    size?: number;
    filePath?: string;
    attachmentTypeId?: number;
    fileContent?: any;
    thumbnail?: string;
    isNew?:boolean;
    isDeleted?:boolean;
    fileData?: any;
    description?:string;
    descriptionEn?: string;
    descriptionAr?: string;
    createdOn?: string | null;
}

export enum AttachmentFileType {
  General = 1,
  Document = 2,
  Image = 3,
  Audio = 4,
  Video = 5,
  PDF = 6,
  CommaSeparated = 7,
  Word = 8,
  PowerPoint = 9,
  ArchiveCompressed = 10,
  Text = 11,
  Excel = 12
}

export const AttachmentFileExtension = {
  audio: 'wma,mp3,m4a',
  video: 'wmv,wav,mpg,mpeg,mp4,mov,flv,avi',
  image: 'jpg,jpeg,png,tif,tiff,gif,bmp,PNG',
  text: 'txt,rtf,pdf',
  commaSeparated: 'csv,xls,xlsx,xlt,xltx',
  word: 'doc,docx,dot,dotx',
  powerPoint: 'ppt,ppsx,pptx,sldx',
  archiveCompressed: 'zip,rar',
  pdf: 'pdf',
  excel: 'xls,xlsx',
};

export enum AttachmentActionEnum {
  download = 1,
  view = 2,
  sendEmail = 3,
}
